import { Box, Typography } from '@mui/material';
import { formatPrice } from '../../../../../services/util/prices/formatPrice';
import React from 'react';

type CheapeastPriceProps = {
  isShowCheapeastActive: boolean;
  totalGreenPrice: number;
};
const Cheapestprice: React.FC<CheapeastPriceProps> = ({
  isShowCheapeastActive,
  totalGreenPrice,
}) => {
  return (
    <Box sx={{ marginTop: 2 }}>
      {isShowCheapeastActive && (
        <Typography variant="h6" color="primary">
          Cheapest Price: &nbsp;
          {formatPrice(totalGreenPrice * 100)} / month
        </Typography>
      )}
    </Box>
  );
};
export default Cheapestprice;
